import { h, render } from "preact";
import {
  LocationFormProvider,
  useLocationFormStorage,
} from "./locationFormContext";
import { LocationInput } from "./locationInput";
import { LocationOverlay } from "./locationOverlay";
import { GuestOverlay } from "./guestOverlay";
import { DateInput } from "./dateInput";
import { GuestInput } from "./guestInput";
import { SubmitButton } from "./submitButton";

export function LocationForm() {
  const {
    showGuestOverlay,
    showAutocompleteOverlay,
    geoItem,
    location,
    adults,
    kids,
    dogs,
    bookingFrom,
    bookingTo,
  } = useLocationFormStorage();

  const toYmd = (value) => {
    if (!value) {
      return null;
    }

    const d = value instanceof Date ? value : new Date(value);

    if (Number.isNaN(d.getTime())) {
      return null;
    }

    // Use local date parts to avoid UTC-based day shifts from toISOString().
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const submit = () => {
    document.dispatchEvent(
      new CustomEvent("locationFormSubmit", {
        detail: {
          geoItem,
          location,
          adults,
          kids,
          dogs,
          bookingFrom: toYmd(bookingFrom),
          bookingTo: toYmd(bookingTo),
        },
      })
    );
  };

  return (
    <div className="grid grid-cols-1 gap-4 md:gap-1 lg:gap-2 md:grid-cols-4">
      <LocationInput />
      <DateInput />
      <GuestInput />
      <SubmitButton onSubmit={submit} />

      {showAutocompleteOverlay && <LocationOverlay />}
      {showGuestOverlay && <GuestOverlay />}
    </div>
  );
}

if (document.getElementById("locationForm")) {
  const container = document.getElementById("locationForm");

  const locationAttr = container.getAttribute("data-location");
  const geoItemAttr = container.getAttribute("data-geo-item");

  const parseGeoItem = (raw) => {
    if (!raw) {
      return undefined;
    }

    try {
      return JSON.parse(raw);
    } catch (error) {
      return undefined;
    }
  };

  const initialValues = {
    location: locationAttr !== null ? locationAttr : undefined,
    geoItem: parseGeoItem(geoItemAttr),
  };

  render(
    h(LocationFormProvider, { initialValues }, h(LocationForm, null)),
    container
  );
}
